<template>
  <v-card class="dt-modal cmp-booking-booking-artist_calendar_date">
    <div class="dt-modal--header">
      <v-layout row wrap px-2>{{ modalHeader }}</v-layout>
    </div>
    <div class="dt-modal--body">
      <v-layout row wrap class="dt-tabs-container" px-2 py-1>
        <v-tabs
          ref="vtabs"
          :value="activeTabIndex"
          color="transparent"
          light
          class="float-window--tab"
        >
          <v-tab
            ripple
            v-for="tab of bookingDetailsModalTabs"
            :key="tab.index"
            @click="(e) => tabSelected(tab.id)"
            >{{ $t(tab.value) }}</v-tab
          >
          <v-tab-item
            v-for="n in bookingDetailsModalTabs"
            :key="n.index"
          ></v-tab-item>
        </v-tabs>
      </v-layout>
      <div
        ref="dtBoxes"
        class="booking-details-boxes"
        :class="{
          'dt-loading': !calendar_date_artist.calendar_date_artist_id,
        }"
      >
        <v-layout row wrap ma-1 mb-3>
          <div class="section-title" :id="bookingDetailsModalTabs[0].id">
            {{$t('performance_details')}}
          </div>
        </v-layout>
        <v-layout row wrap ma-1>
          <v-flex md6 pa-1>
            <div class="box-widget selected">
              <div class="box-header gray">
                <div class="box-header--name"> {{$t('schedule')}} </div>
              </div>
              <div class="box-body">
                <div class="form-group" v-if="calendar_date_artist">
                  <TextField
                    :id="'stage_name'"
                    v-bind="textFieldConfig"
                    v-model="calendar_date_artist.stage_name"
                    isModel
                    style="background-color: white"
                    :placeholder="$t('stage')"
                    @validated="onValidation"
                  ></TextField>
                  <TextField
                    :id="'soundcheck'"
                    v-bind="textFieldConfig"
                    v-model="calendar_date_artist.soundcheck"
                    isModel
                    style="background-color: white"
                    :placeholder="$t('soundcheck')"
                    @validated="onValidation"
                  ></TextField>
                  <TextField
                    :id="'performance_type'"
                    v-bind="textFieldConfig"
                    v-model="calendar_date_artist.performance_type"
                    isModel
                    style="background-color: white"
                    :placeholder="$t('performance_type')"
                    @validated="onValidation"
                  ></TextField>
                  <TextField
                    :id="'performance_time'"
                    v-bind="textFieldConfig"
                    v-model="calendar_date_artist.performance_time"
                    isModel
                    style="background-color: white"
                    :placeholder="$t('stage_time')"
                    @validated="onValidation"
                  ></TextField>
                  <TextField
                    :id="'performance_time_contract'"
                    v-bind="textFieldConfig"
                    v-model="calendar_date_artist.performance_time_contract"
                    isModel
                    style="background-color: white"
                    :placeholder="$t('set_duration')"
                    @validated="onValidation"
                  ></TextField>
                  <TextField
                    :id="'artist_before'"
                    v-bind="textFieldConfig"
                    v-model="calendar_date_artist.artist_before"
                    isModel
                    style="background-color: white"
                    :placeholder="$t('artist_before')"
                    @validated="onValidation"
                  ></TextField>
                  <TextField
                    :id="'artist_after'"
                    v-bind="textFieldConfig"
                    v-model="calendar_date_artist.artist_after"
                    isModel
                    style="background-color: white"
                    :placeholder="$t('artist_after')"
                    @validated="onValidation"
                  ></TextField>
                  <!-- <TextField 
                          :id="'playlist_id'"
                          v-bind="textFieldConfig"
                          v-model="calendar_date_artist.playlist_id"
                          isModel
                          :placeholder="$t('playlist')"
                          @validated="onValidation"
                  ></TextField>-->
                  <Dropdown
                    class="dt-dropdown m1"
                    :options="playlistItems"
                    :selected="selectedPlaylist"
                    :placeholder="$t('playlist')"
                    box
                    style="background-color: white"
                    deselect
                    v-on:selectedChange="
                      (e) => onDropdownChange('playlist_id', e)
                    "
                    :listHeight="95"
                  ></Dropdown>
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex md6 pa-1>
            <div class="box-widget selected">
              <div class="box-header gray">
                <div class="box-header--name"> {{$t('room_requirements')}} </div>
              </div>
              <div class="box-body">
                <div class="form-group">
                  <TextField
                    :id="'date_hotel_start'"
                    v-bind="textFieldConfig"
                    v-model="calendar_date_artist.date_hotel_start"
                    isModel
                    style="background-color: white"
                    :placeholder="$t('from')"
                    @validated="onValidation"
                  ></TextField>
                  <TextField
                    :id="'date_hotel_end'"
                    v-bind="textFieldConfig"
                    v-model="calendar_date_artist.date_hotel_end"
                    isModel
                    style="background-color: white"
                    :placeholder="$t('until')"
                    @validated="onValidation"
                  ></TextField>
                  <TextField
                    :id="'single_rooms'"
                    v-bind="textFieldConfig"
                    v-model="calendar_date_artist.single_rooms"
                    isModel
                    style="background-color: white"
                    :placeholder="$t('single_rooms')"
                    @validated="onValidation"
                  ></TextField>
                  <TextField
                    :id="'double_rooms'"
                    v-bind="textFieldConfig"
                    v-model="calendar_date_artist.double_rooms"
                    isModel
                    style="background-color: white"
                    :placeholder="$t('double_rooms')"
                    @validated="onValidation"
                  ></TextField>
                  <TextField
                    :id="'suites'"
                    v-bind="textFieldConfig"
                    v-model="calendar_date_artist.suites"
                    isModel
                    style="background-color: white"
                    :placeholder="$t('suites')"
                    @validated="onValidation"
                  ></TextField>
                  <TextField
                    :id="'hotel_class'"
                    v-bind="textFieldConfig"
                    v-model="calendar_date_artist.hotel_class"
                    isModel
                    style="background-color: white"
                    :placeholder="$t('hotel_class')"
                    @validated="onValidation"
                  ></TextField>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap ma-1>
          <v-flex md6 pa-1>
            <div class="box-widget selected">
              <div class="box-header gray">
                <div class="box-header--name"> {{$t('schedule_notes')}} </div>
              </div>
              <div class="box-body">
                <div class="dbox-textarea-container">
                  <textarea
                    name="scheduleNotes"
                    id="scheduleNotes"
                    style="background-color: white"
                    v-on:blur="onScheduleNotesBlur"
                    v-model="calendar_date_artist.schedule_notes"
                  ></textarea>
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex md6 pa-1>
            <div class="box-widget selected">
              <div class="box-header gray">
                <div class="box-header--name"></div>
              </div>
              <div class="box-body">
                <div class="form-group">
                  <TextField
                    :id="'travel_qty'"
                    v-bind="textFieldConfig"
                    v-model="calendar_date_artist.travel_qty"
                    isModel
                    style="background-color: white"
                    :placeholder="$t('qty')"
                    @validated="onValidation"
                  ></TextField>
                  <Dropdown
                    class="dt-dropdown m1"
                    :options="travelOptionItems"
                    :selected="
                      travelOptionItems.find(
                        (e) => e.text == calendar_date_artist.travel_options
                      )
                    "
                    :placeholder="$t('travel_options')"
                    box
                    style="background-color: white"
                    v-on:selectedChange="
                      (e) => onDropdownChange('travel_options', e)
                    "
                    :listHeight="95"
                  ></Dropdown>
                  <Dropdown
                    class="dt-dropdown m1"
                    :options="travelOptionItems"
                    :selected="
                      travelOptionItems.find(
                        (e) => e.value == calendar_date_artist.travel_option2
                      )
                    "
                    :placeholder="$t('second_travel_option')"
                    box
                    style="background-color: white"
                    v-on:selectedChange="
                      (e) => onDropdownChange('travel_option2', e)
                    "
                    :listHeight="95"
                  ></Dropdown>
                  <TextField
                    style="background-color: white"
                    :id="'guestlist_tickets'"
                    v-bind="textFieldConfig"
                    v-model="calendar_date_artist.guestlist_tickets"
                    isModel
                    :placeholder="$t('guestlist_tickets')"
                    @validated="onValidation"
                  ></TextField>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap ma-1 mb-3>
          <div class="separator"></div>
          <div class="section-title" :id="bookingDetailsModalTabs[1].id">
            {{$t('other_details')}}
          </div>
        </v-layout>
        <v-layout row wrap ma-1>
          <v-flex md6 pa-1>
            <div class="box-widget selected">
              <div class="box-header gray">
                <div class="box-header--name"> {{$t('custom_fields')}} </div>
              </div>
              <div class="box-body">
                <CustomFields
                  v-if="artistDetails"
                  :fields="artistDetails.custom_fields"
                  :section="'bsettings'"
                  :externalId="calendarDateArtistId"
                  :externalTable="'calendar_date_artists'"
                  :module="'contacts'"
                  @changed="onCustomFieldsChanged"
                />
              </div>
            </div>
          </v-flex>
          <v-flex md6 pa-1>
            <div class="box-widget selected">
              <div class="box-header gray">
                <div class="box-header--name"> {{$t('guest_list')}} </div>
              </div>
              <div class="box-body">
                <div class="dbox-textarea-container">
                  <textarea
                    style="background-color: white"
                    name="guestList"
                    id="guestList"
                    v-on:blur="onGuestListBlur"
                    v-model="calendar_date_artist.guestlist"
                  ></textarea>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap ma-1 mb-3>
          <div class="separator"></div>
          <div class="section-title" :id="bookingDetailsModalTabs[2].id">
            {{$t('requirement_english')}}
          </div>
        </v-layout>
        <v-layout row wrap ma-1>
          <v-flex md6 pa-1>
            <div class="box-widget selected">
              <div class="box-header gray">
                <div class="box-header--name">
                  {{$t('techrider_requirements')}}
                </div>
              </div>
              <div class="box-body">
                <div class="dbox-textarea-container">
                  <textarea
                    style="background-color: white"
                    name="techrider"
                    id="techrider"
                    v-on:blur="onGuestListBlur"
                    v-model="calendar_date_artist.techrider"
                  ></textarea>
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex md6 pa-1>
            <div class="box-widget selected">
              <div class="box-header gray">
                <div class="box-header--name">
                  {{$t('travel_requirements')}}
                </div>
              </div>
              <div class="box-body">
                <div class="dbox-textarea-container">
                  <textarea
                    style="background-color: white"
                    name="travel_class"
                    id="travel_class"
                    v-on:blur="onGuestListBlur"
                    v-model="calendar_date_artist.travel_class"
                  ></textarea>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap ma-1>
          <v-flex md6 pa-1>
            <div class="box-widget selected">
              <div class="box-header gray">
                <div class="box-header--name">
                  {{$t('hotel_requirements')}}
                </div>
              </div>
              <div class="box-body">
                <div class="dbox-textarea-container">
                  <textarea
                    style="background-color: white"
                    name="hotel_class"
                    id="hotel_class"
                    v-on:blur="onGuestListBlur"
                    v-model="calendar_date_artist.hotel_class"
                  ></textarea>
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex md6 pa-1>
            <div class="box-widget selected">
              <div class="box-header gray">
                <div class="box-header--name">
                  {{$t('catering_requirements')}}
                </div>
              </div>
              <div class="box-body">
                <div class="dbox-textarea-container">
                  <textarea
                    style="background-color: white"
                    name="catering"
                    id="catering"
                    v-on:blur="onGuestListBlur"
                    v-model="calendar_date_artist.catering"
                  ></textarea>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap ma-1 mb-3>
          <div class="separator"></div>
          <div class="section-title" :id="bookingDetailsModalTabs[3].id">
            {{$t('requirement2nd_language')}}
          </div>
        </v-layout>
        <v-layout row wrap ma-1>
          <v-flex md6 pa-1>
            <div class="box-widget selected">
              <div class="box-header gray">
                <div class="box-header--name">
                  {{$t('techrider_requirements')}}
                </div>
              </div>
              <div class="box-body">
                <div class="dbox-textarea-container">
                  <textarea
                    style="background-color: white"
                    name="techrider2"
                    id="techrider2"
                    v-on:blur="onGuestListBlur"
                    v-model="calendar_date_artist.techrider2"
                  ></textarea>
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex md6 pa-1>
            <div class="box-widget selected">
              <div class="box-header gray">
                <div class="box-header--name">
                  {{$t('travel_requirements')}}
                </div>
              </div>
              <div class="box-body">
                <div class="dbox-textarea-container">
                  <textarea
                    style="background-color: white"
                    name="travel_class2"
                    id="travel_class2"
                    v-on:blur="onGuestListBlur"
                    v-model="calendar_date_artist.travel_class2"
                  ></textarea>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
        <v-layout row wrap ma-1>
          <v-flex md6 pa-1>
            <div class="box-widget selected">
              <div class="box-header gray">
                <div class="box-header--name">
                  {{$t('hotel_requirements')}}
                </div>
              </div>
              <div class="box-body">
                <div class="dbox-textarea-container">
                  <textarea
                    style="background-color: white"
                    name="hotel_class2"
                    id="hotel_class2"
                    v-on:blur="onGuestListBlur"
                    v-model="calendar_date_artist.hotel_class2"
                  ></textarea>
                </div>
              </div>
            </div>
          </v-flex>
          <v-flex md6 pa-1>
            <div class="box-widget selected">
              <div class="box-header gray">
                <div class="box-header--name">
                  {{$t('catering_requirements')}}
                </div>
              </div>
              <div class="box-body">
                <div class="dbox-textarea-container">
                  <textarea
                    style="background-color: white"
                    name="catering2"
                    id="catering2"
                    v-on:blur="onGuestListBlur"
                    v-model="calendar_date_artist.catering2"
                  ></textarea>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </div>
      <v-layout row wrap>
        <v-layout style="padding: 20px 3px 0px 3px" md4>
          <div class="flex">
            <button class="dt-button s5" @click.stop="onLoadDefaults">
              {{$t('load_defaults')}}
            </button>
          </div>

          <button class="dt-button s2" @click="onCancelClick"> {{$t('cancel')}} </button>
          <button class="dt-button v1 s2" @click="onOKClicked"> {{$t('ok')}} </button>
        </v-layout>
      </v-layout>
    </div>
  </v-card>
</template>

<script>
import * as R from "ramda";
import Dropdown from "@plugins/dropdown/dropdown";
import TextField from "@plugins/text-field/text-field";
import { BookingService } from "../../services/booking-service";
import { validPositiveNumber, waitForAnimation } from "../../../../utility";
import {
  createCalendarDateArtists,
  makeTravelOptionItems,
  createCalendarDateArtist,
  getPlaylistsResponse,
  playlistsTextValue,
} from "../../models/calendar-date-artist.model.js";
import { scrollToWithAnimation } from "../../../../plugins/scroller/scrollTo";
import CustomFields from "@/dt-plugins/custom-fields/custom-fields";

export default {
  components: {
    TextField,
    Dropdown,
    CustomFields,
  },
  props: {
    artistCalendarDateProp: {
      types: Object,
    },
  },
  data: function () {
    return {
      calendar_date_artist: createCalendarDateArtist(),
      active: null,
      activeTab: null,
      bookingDetailsModalTabs: [
        { index: 0, value: "performance_details", id: "performance_details" },
        { index: 1, value: "other_details", id: "other_details" },
        { index: 2, value: "requirements_english", id: "requirement_english" },
        {
          index: 3,
          value: "requirements_2nd_language",
          id: "requirement_2nd_lang",
        },
      ],
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
      },
      travelOptions: null,
      playlists: [],
      selectedTravelOption1: null,
      selectedTravelOption2: null,
      firstTabSelectedCallFlag: true,

      artistDetails: null,
      calendarDateArtistId: null,
    };
  },
  mounted: function () {
    setTimeout(() => {
      this.active = 2;
    }, 2000);
  },
  watch: {
    artistCalendarDateProp: {
      immediate: true,
      handler: function (newVal, oldVal) {
        // console.log("Log: newVal", newVal);
        if (
          newVal.calendarDateArtistId == (oldVal && oldVal.calendarDateArtistId)
        ) {
          return;
        }

        const { calendarDateArtistId, calendarDateId } = newVal;
        this.calendarDateArtistId = calendarDateArtistId;
        if (
          validPositiveNumber(calendarDateArtistId) &&
          validPositiveNumber(calendarDateId)
        ) {
          BookingService.findArtistDetails({
            calendarDateArtistId,
            calendarDateId,
          }).then((res) => {
            this.artistDetails = res.data;
            console.log("findArtistDetails", res);
            this.calendar_date_artist = createCalendarDateArtist(
              res.data.calendar_date_artist
            );
            this.travelOptions = res.data.travel_options;
            this.playlists = getPlaylistsResponse(res);
            console.log(this.calendar_date_artists);
          });
        }
      },
    },
    $route: {
      immediate: true,
      handler: function (to, from) {
        if (to.query.tab) {
          setTimeout(() => {
            this.scrollToTab(to.query.tab);
          }, 1);
        }
      },
    },
  },
  computed: {
    modalHeader: function () {
      if (this.calendar_date_artists) {
        return `|${this.calendar_date_artists.booking_location_name}| ${this.calendar_date_artists.artist_name}|${this.calendar_date_artists.city}`;
      } else {
        return "";
      }
    },
    travelOptionItems: function () {
      return (
        this.travelOptions?.map((t) => ({
          text: t.travel_option_text,
          value: t.travel_option_id,
        })) || []
      );
    },
    playlistItems: function () {
      return playlistsTextValue(this.playlists);
    },
    selectedPlaylist: function () {
      return this.playlistItems.find(
        (e) => e.value === this.calendar_date_artist.playlist_id
      );
    },
    activeTabIndex: function () {
      if (this.$route && this.$route.params.tab) {
        const tabId = this.$route.query.tab;
        const activeTab = this.bookingDetailsModalTabs.find(
          (e) => e.id === tabId
        );
        return activeTab && `${activeTab.index}`;
      } else {
        return "performance_details";
      }
    },
    activeTabId: function () {
      if (this.$route && this.$route.params.tab) {
        const tabId = this.$route.query.tab;
        console.log(tabId, this.bookingDetailsModalTabs);
        const activeTab = this.bookingDetailsModalTabs.find(
          (e) => e.id === tabId
        );
        return activeTab && activeTab.id;
      } else {
        return 2;
      }
    },
  },
  methods: {
    tabSelected: function (selectedTabId) {
      // console.log(selectedTabIndex);
      // console.log(this.bookingDetailsModalTabs, selectedTab);
      const selectedTab = this.bookingDetailsModalTabs.find(
        (e) => e.id == selectedTabId
      );
      this.$router.push({
        name: this.$route.name,
        query: { ...this.$route.query, tab: selectedTab.id },
      });
      // if (!this.firstTabSelectedCallFlag) {
      // } else {
      //   this.firstTabSelectedCallFlag = false;
      // }
    },

    async fetchData() {
      const res = await BookingService.bookingArtistInfo(
        this.artistCalendarDateProp.calendarDateArtistId
      );
      this.calendar_date_artist = { ...this.calendar_date_artist, ...res.data };
    },

    onLoadDefaults: async function () {
      await BookingService.loadDefaults(
        this.artistCalendarDateProp.calendarDateArtistId
      );
      this.fetchData();
    },
    onOKClicked: function (event) {
      console.log(this.calendar_date_artist);
      // this.active = '2';
      BookingService.modifyCalendarDateArtist({
        calendarDateArtist: this.calendar_date_artist,
      }).then((res) => {
        this.done();
      });
    },
    onCancelClick: function () {
      this.$emit("cancelled", true);
    },
    done: function () {
      this.$emit("done", {
        item: this.calendar_date_artist,
        name: "calendar_date_artist",
      });
    },
    onValidation: function (res) {},
    onDropdownChange: function (name, event) {
      console.log(name, event);
      if (event && event.value) {
        this.calendar_date_artist[name] = event.value;
      } else {
        this.calendar_date_artist[name] = "";
      }
      console.log(this.selectedPlaylist);
      console.log(this.calendar_date_artist);
      // switch (name) {
      //   case 'travel_options':
      //   case 'travel_option2': {
      //     this.calendar_date_artist[name] = event.value;
      //     break;
      //   }
      //   case 'playlist_id': {
      //     this.calendar_date_artist[name] = event.value;
      //     break;
      //   }
      //   default:
      //     break;
      // }
    },
    onScheduleNotesBlur: function (event) {},
    onGuestListBlur: function (event) {},
    scrollToTab: function (tab) {
      if (!this.$refs.dtBoxes) {
        return;
      }
      // console.error(tab, this.$refs.dtBoxes);

      const selectedTabIndex = this.bookingDetailsModalTabs.find(
        (e) => e.id === tab
      );

      const activeTab = selectedTabIndex && selectedTabIndex.index;
      // debugger;
      // if (this.activeTab !== activeTab) {
      //   console.log('this.activeTab, activeTab', this.activeTab, activeTab)
      //   const self = this;
      //   console.log('this.activeTab, activeTab', this.activeTab, activeTab)
      //   setTimeout(() => {
      //     console.log(this, self);
      //     // self.activeTab = activeTab;
      //     // self.$refs.vtabs.activeTab = activeTab;
      //     // self.$refs.vtabs.activeIndex = activeTab;
      //     // console.log(self.$refs.vtabs);

      //   }, 1000);
      // }
      // this.$nextTick(() => {
      //   debugger;
      //   this.activeTab = activeTab;
      // })
      console.error(this.$refs.vtabs);

      const tabElement = document.getElementById(tab);

      // console.log(tab, tabElement.getBoundingClientRect().top - this.$refs.dtBoxes.scrollTop);

      // const gridItem = this.gridLayout.layout.find(e => e.id === `VGI_${selectedTab.VGI_ID}`);

      // const sectionElement = document.getElementById(gridItem.id);

      // const transformValue = getGITranslate(sectionElement.style.transform);

      scrollToWithAnimation(
        this.$refs.dtBoxes,
        tabElement.offsetTop - 130,
        200
      );
    },
    onCustomFieldsChanged(payload) {
      console.log({ payload: payload });
    },
  },
};
</script>

<style lang="scss">
.cmp-booking-booking-artist_calendar_date {
  .dt-tabs-container
    .float-window--tab
    .tabs__bar
    .tabs__wrapper
    .tabs__container {
    background: white !important;
  }
  .dt-tabs-container {
    background: white !important;
    .float-window--tab {
      background: white !important;
      .tabs__bar {
        background: white !important;
        .tabs__wrapper {
          background: white !important;
          .tabs__container {
            background: white !important;
          }
        }
      }
    }
  }

  .section-title {
    margin-top: 8px;
    margin-left: 8px;
    color: var(--text-secondary);
    font-size: 14px;
  }
}
</style>

<style lang="scss" scoped>
.dt-modal {
  .dt-modal--header {
    text-transform: none;
  }
}

.float-window--tab {
  width: 100%;
}

.form-group {
  padding: 10px;

  .dt-input-box--container {
    margin: 5px 0px;
  }
}

.booking-details-boxes {
}

.box-widget {
  // margin: 4px;
}

textarea {
  height: 220px;
}
</style>
